import trainingIndex from 'actions/training/index';
import schoolIndex from 'actions/school/index';
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import FluidGrid from 'components/UI/FluidGrid';
import HeroLayout from 'components/UI/HeroLayout';
import React, { createContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Filter from './components/Filter';
import InformationModal from 'components/UI/trainingModals/InformationModal';
import InterestModal from 'components/UI/trainingModals/InterestModal';
import SubscriptionModal from 'components/UI/trainingModals/SubscriptionModal';
import TrainingCard from 'components/UI/TrainingCard';
import useSchoolData from 'hooks/useSchoolData';
import useTrainings from 'hooks/useTrainings';
import useActiveModal from 'hooks/useActiveModal';
import './index.module.scss';

export const GroeiContext = createContext(null);

export default function Groei() {
    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState('');
    const [targetGroupSelected, setTargetGroupSelected] = useState([]);
    const [themeSelected, setThemeSelected] = useState([]);
    const [experienceSelected, setExperienceSelected] = useState([]);
    const [startMonthSelected, setStartMonthSelected] = useState([]);

    useEffect(() => {
        dispatch(trainingIndex());
        dispatch(schoolIndex);
    }, []);

    // Use custom hooks for data fetching and structuring
    const { school, schoolGroup, isSchoolsTrainingPage } = useSchoolData();

    const trainings = useTrainings({
        searchValue,
        targetGroupSelected,
        experienceSelected,
        themeSelected,
        startMonthSelected,
        isSchoolsTrainingPage,
        school,
        schoolGroup,
    });

    const { activeModal, training_url } = useActiveModal(
        trainings,
        isSchoolsTrainingPage,
        school,
        schoolGroup
    );

    return (
        <GroeiContext.Provider
            value={{
                searchValue,
                setSearchValue,
                targetGroupSelected,
                setTargetGroupSelected,
                startMonthSelected,
                themeSelected,
                setThemeSelected,
                experienceSelected,
                setExperienceSelected,
                setStartMonthSelected,
                isSchoolsTrainingPage,
            }}
        >
            <Layout>
                <Container>
                    <HeroLayout>
                        {/* <Buttons /> */}
                        <div
                            styleName={`wrapper ${
                                isSchoolsTrainingPage ? 'school' : ''
                            }`}
                        >
                            {!isSchoolsTrainingPage && <Filter />}
                            <FluidGrid
                                items={trainings}
                                component={<TrainingCard isSchoolsTrainingPage={isSchoolsTrainingPage} />}
                                isSchoolsTrainingPage={isSchoolsTrainingPage}
                            />
                        </div>
                        <InformationModal
                            isSchoolsTrainingPage={isSchoolsTrainingPage}
                            training_url={training_url}
                            training={activeModal}
                        />
                        <SubscriptionModal
                            isSchoolsTrainingPage={isSchoolsTrainingPage}
                            training_url={training_url}
                            training={activeModal}
                            schoolGroup={schoolGroup}
                        />
                        <InterestModal
                            isSchoolsTrainingPage={isSchoolsTrainingPage}
                            training_url={training_url}
                            training={activeModal}
                        />
                    </HeroLayout>
                </Container>
            </Layout>
        </GroeiContext.Provider>
    );
}
